import { useContext } from 'react';

import { PortalIdentifier } from '../common/Portal';
import { PortalContext } from '../context/PortalContext';
import { useLagoon } from '../hooks/useLagoon';
import { getLagoonConfigValue } from './providerSearch.utils';

/**
 * Determines if GEHA V2 icons/styling should be used based on portal identifier and Container Config value
 * Gets portal data internally, no parameters needed
 * @returns true if GEHA V2 styling should be used
 */
export const shouldUseGehaV2Styling = (): boolean => {
  const { portalData } = useContext(PortalContext);
  const portalIdentifier = portalData?.portalIdentifier;

  const allConfigs = useLagoon('container-config');
  const themeGehaValue =
    portalData?.portalConfig?.themeVersion ||
    getLagoonConfigValue(allConfigs, 'THEME_GEHA');
  const isThemeGehaV2Enabled = themeGehaValue === 'v2';

  const isGeha = portalIdentifier === PortalIdentifier.GEHA;
  const isGEHAV2 = portalIdentifier === PortalIdentifier.GEHA_V2;

  const result = isThemeGehaV2Enabled && (isGeha || isGEHAV2);

  if (result) {
    return true;
  }

  return false;
};
